import React, { useEffect, useRef } from 'react'
import Header from './Header'

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
// import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import config from "../../config"
import download from 'downloadjs'
import Moment from 'react-moment';
import TablePagination from '@mui/material/TablePagination';
import { DateRangePicker } from 'react-date-range';
import { addDays } from "date-fns";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';

import { useDownloadExcel } from 'react-export-table-to-excel';

import { useNetworkState } from 'react-use';
import * as XLSX from 'xlsx'
import Footer from './Footer';
import moment from 'moment'

import $ from 'jquery'; 
import 'daterangepicker/daterangepicker.css'; // Import daterangepicker CSS
import 'daterangepicker';

const Reports = () => {
  function todayDateString() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // State for storing the selected dates
 
    const tableRef = useRef(null);
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    let navigate = useNavigate();
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====shipments====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
   
    const [date, setDate] = React.useState({
      start_date: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD')
    });
    console.log("date == " , date)
   
    // Function to get today's date in the format required by the date input (YYYY-MM-DD)
   
  
  
    const [state, setState] = React.useState([
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 0),
          key: "selection",
          isOpen: false,
        },
      ]);
      // console.log("state === " ,  state)
      var months = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ];
      var days = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ];
    
      const xcc =
        state[0].startDate.getFullYear() +
        "-" +
        months[state[0].startDate.getMonth()] +
        "-" +
        days[state[0].startDate.getDate()];
      const ycc =
        state[0].endDate.getFullYear() +
        "-" +
        months[state[0].endDate.getMonth()] +
        "-" +
        days[state[0].endDate.getDate()];
  
  
  const [searchfilters, setsearchFilters] = React.useState({ filterStatus:[]})
  // console.log("searchfilters == " , searchfilters)
 
  // console.log("dimensionState= " , dimensionState)
  const [isLoading, setIsLoading] = React.useState(false);
  const[shipstate, setShipstate]= React.useState([])
  const[shipcount, setShipcount]= React.useState({count:0 , amount:0})
   const[bookorder , setbookorder] = React.useState([])
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
 const [openOffdetailcanvas, setOpenOffdetailcanvas] = React.useState(false);
 const [trackingstate,setTrackingState] = React.useState({track:{},isLoading:true})
  const [stateship, setStateship] = React.useState({ shipmentDetail: {sender:{},receiver:{},items:[] }, isLoading: true,detailFound:false,parcel_count:0  })
  const[failedstate , setfailed] = React.useState({failed:""})
  const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
      const homeSection = document.querySelector('.home-section');
      if (homeSection) {
          homeSection.classList.toggle('sidebar-closed');
      }
  };
  // console.log("rstate= " , rstate)
  
  const filter=(e,values)=>{
    const name = e.target.name;
    const value = values;
    const isChecked = e.target.checked;
  
    // Create a new array by spreading the existing filterStatus array
    const updatedFilterStatus = [...searchfilters.filterStatus];
  
    if (isChecked) {
      updatedFilterStatus.push(value);
    } else {
      // Remove the value from the array if unchecked
      const index = updatedFilterStatus.indexOf(value);
      if (index !== -1) {
        updatedFilterStatus.splice(index, 1);
      }
    }
  
    // Update the searchfilters state with the updated filterStatus array
    setsearchFilters((prevFilters) => ({
      ...prevFilters,
      filterStatus: updatedFilterStatus,
    }));
  }
  React.useEffect(()=>{
    getData()
  },[])
        const getData = () => {
            setIsLoading(true)
            const currentDate = new Date();
            const startDate = date.start_date !== "" ? date.start_date : currentDate.toISOString().slice(0,10);
            const endDate = date.end_date !== "" ? date.end_date : currentDate.toISOString().slice(0,10);
            let sendData = {
            //   indexValue: index,
            //   limit: perPage,
              from_start_date: startDate,
              to_start_date: endDate,
              customer_id:userData.customer_id,
              status:searchfilters.filterStatus,
             
            };
            let full_api =  config.apiUrl + '/shipment/shipment_reports';
           
            
        // console.log("sendData",sendData)
        axios.post(full_api, sendData, { headers: config.headers }).then(res => {
            // setdimensionState(res.data.output);
            if(res.data.status==true){
                setIsLoading(false)
                setShipstate(res.data.output)
                setShipcount({count:res.data.count , amount:res.data.amount})
            }
            
            // console.log("rnmmmmm", res);
          }).catch((e) => {
            // toast.configure()
             //toast.error("Some thing went wrong")
            // console.log("----error:   ", e);
          })
          };
          const { onDownload } = useDownloadExcel({
            currentTableRef: tableRef.current,
            filename: 'Reports Table',
            sheet: 'Shipment Reports'
        })
        const transformDataForExcel = () => {
          return shipstate.map(item => {
            console.log("created == ", item.created)
            const formattedDate = item.created
              ? new Date(item.created * 1000).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })
              : '';
      
            const formattedTime = item.created
              ? new Date(item.created * 1000).toLocaleTimeString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true,
              })
              : '';
            return {
              'Tracking Id': item?.carrier_tracking_number || '',
              'Reference Number': item?.order_number || '',
              'Pickup Warehouse': item?.warehouse_id || item.warehouse_name ||"",
              'Order Mode': item?.channel_name || "Custom-Single",
              'Receiver Name': item?.receiver[0]?.name || '',
              'Address': item?.receiver[0]?.address || '',
              'Mobile Number': item?.receiver[0]?.mobile || '',
              'City': item?.receiver[0]?.city || '',
              'State': item?.receiver[0]?.state || '',
              'Pincode': item?.receiver[0]?.pincode || '',
              // 'Carrier': item?.carrier_name || '',
              'Mode':  item?.product_type_name || '',
              'Carrier Product': item?.service_provider || '',
              'Current Status': getStatusText(item?.status) || '',
              'Weight (kg)': item?.total_weight || '',
              'L': item?.length || '',
              'B':item?.width || '',
              'H':item?.height || '',
              'Volumetric Weight (kg)': item?.volumetric_weight || '',
              'Chargeable Weight': item?.dead_weight || '',
              'Shipping Fee (₹)': item?.total_amount || '',
              'Shipment type': item?.type || '',
              'Payment Mode': item?.payment_mode === 'cod' || item?.payment_mode === 'cash' ? 'COD' : item?.payment_mode || '',
              'COD Amount': item?.cod_amount || '',
              'Zone Name':item?.zone_name || '',
              'Date': formattedDate,
              'Time': formattedTime,
            }
          });
        };
      
        const getStatusText = (status) => {
          // Define your status mappings here
          const statusMappings = {
            0: 'Pending',
            10: 'RTO',
            1: 'Pick Up Awaited',
            2: 'Picked Up',
            3: 'In Transit',
            4: 'Out For Delivery',
            5: 'Delivered',
            6: 'Cancelled',
            7: 'Failed',
            8: 'NDR',
            9: 'Pickup Scheduled',
            16: 'RTO Delivered',
            19: 'RTO In Transit',
            20: 'Lost',

      
          };
      
      
          return statusMappings[status] || '';
        }
        // const { onDownload } = useDownloadExcel({
        //   data: transformDataForExcel(),
        //   filename: 'Reports Table',
        //   sheet: 'Shipment Reports'
        // });
        const downloadExcel = () => {
          const data = transformDataForExcel();
          const ws = XLSX.utils.json_to_sheet(data);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Shipment Reports');
          XLSX.writeFile(wb, 'Reports Table.xlsx');
        };

        const handleDate =(start, end)=>{
            setDate({...date, start_date:moment(start).format('YYYY-MM-DD'), end_date:moment(end).format("YYYY-MM-DD")})
        }
        React.useEffect(() => {
            // Initialize date range picker with today's date as the default range
            $('.custom-daterange').daterangepicker({
                opens: 'right',
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),  // Set start date to today's date
                endDate: moment().startOf('day'),    // Set end date to today's date
                autoUpdateInput: true,
                locale: {
                    format: 'YYYY-MM-DD'             // Display format
                }
            }, (start, end) => {
                handleDate(start, end); 
             
                      // Update selected range when a new range is chosen
            });
          
            // Set initial value in the input to show today's date
            $('.custom-daterange').val(`${moment().subtract(30, 'days').format('YYYY-MM-DD')} to ${moment().format('YYYY-MM-DD')}`);
          }, []);

          const copyAWBToClipboard = (item) => {
            navigator.clipboard.writeText(item).then(() => {
             
              const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
                Toast.fire({
                background:"#3659cd",
                type: 'success',
                title: "AWB number copied to clipboard!",
                color:"white"
              });
            }).catch((err) => {
              console.error("Failed to copy text: ", err);
            });
          };
          const copyToClipboard = (item) => {
            navigator.clipboard.writeText(item).then(() => {
             
              const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
              })
                Toast.fire({
                background:"#3659cd",
                type: 'success',
                title: "Order number copied to clipboard!",
                color:"white"
              });
            }).catch((err) => {
              console.error("Failed to copy text: ", err);
            });
          };

          const shipment_tracking = (shipment_id) =>{
      
            let full_api = config.apiUrl + `/shipment/shipment_tracking`;
           let sendData = {customer_id:userData.customer_id , trackingNumber:shipment_id};
           // console.log("sendData",sendData)
            
           axios.post(full_api, sendData, { headers: config.headers }).then(res => {
            if(res.data.status==200){
               setTrackingState({...trackingstate,track:res.data.output,isLoading:false})
               // console.log("res",trackingstate.track)
               setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading:false})
             
            }
            else{
             setTrackingState({...trackingstate,track:res.data.output,isLoading:false})
             // console.log("res",trackingstate.track)
             setStateship({ ...stateship, shipmentDetail: res.data.ship_detail, isLoading:false})
            }
           
            
           }).catch((e) => {
             // toast.configure()
              //toast.error("Some thing went wrong")
             // console.log("----error:   ", e);
           })
          }


const shipment_failed = (shipment_id) =>{
      
  let full_api = config.apiUrl + `/shipment/check_failed_shipments`;
 let sendData = {shipment_id:shipment_id};
 // console.log("sendData",sendData)
  
 axios.post(full_api, sendData, { headers: config.headers }).then(res => {
  setfailed({...failedstate , failed:res.data.output})
 
  
 }).catch((e) => {
   // toast.configure()
    //toast.error("Some thing went wrong")
   // console.log("----error:   ", e);
 })
}

          const openOffdetailcanvasHandler = (sub) => {
            setOpenOffdetailcanvas(true);
        setbookorder(sub)
        shipment_tracking(sub.shipment_id)
        shipment_failed(sub.shipment_id)
           
          };

          const closeOffdetailcanvasHandler = () => {
            setOpenOffdetailcanvas(false);
            setbookorder([])
            setTrackingState({track:{},isLoading:true})
            setStateship({ shipmentDetail: {sender:{},receiver:{},items:[] }, isLoading: true,detailFound:false,parcel_count:0  })
            setfailed({failed:""})
            // Call your get_list function here if needed
            // get_list(sub);
          };  
        
  return (
    <div>
    
  
    <Header/>
 <div class="page-wrapper pinned">
  <div class="main-container">
   <div className='app-container'>
  <div class="app-body">
  <div class="container-fluid"> 

<div class="mob_nav">
  <div class="row">
      <div class="col-6">
        <div class=" d-flex justify-content-start ">
          <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
          <h2>Shipment Report</h2>
        </div>
      </div>
      <div class="col text-end">
      </div>
  </div>
</div>


<div class="row justify-content-between desk_nav">
    <div class="col-12 col-md-4 ">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>Shipment Report</h2>
      </div>
    </div>
    <div class="col-12 col-md-4 mb-3">
      <div class="row justify-content-end">
          <div class="col-6 col-md-6">
            
          </div>
          <div class="col-6 col-md-4">
            
          </div>
      </div>
    </div>
</div>



<div class="card mb-3">
  <div class="card-body">
    <div class="row justify-content-between">
        <div class="col-12 col-md-6 mb-1">
          <div class="row g-1">
              <div class="col-12 col-md-6">
                <div class="input-group">
                  <input type="text" class="form-control custom-daterange" />
                  <span class="input-group-text">
                    <i class="bi bi-calendar2-range"></i>
                  </span>
                </div>
              </div>
              <div class="col-12 col-md-2">
                <div class="dropdown">
                  <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown">
                    All Status
                  </button>
                  <ul class="dropdown-menu">
                    <li class="px-3">
                      <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="check1" name="pickup_awaited" value="something"  onChange={(e)=>filter(e,1)}/>
                      <label class="form-check-label">Pickup Awaited</label>
                      </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="pickup_scheduled" value="something" onChange={(e)=>filter(e,9)}/>
                               <label class="form-check-label">Pickup Scheduled</label>
                           </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="picked_up" value="something"  onChange={(e)=>filter(e,2)}/>
                               <label class="form-check-label">Picked Up</label>
                           </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="in_transit" value="something"  onChange={(e)=>filter(e,3)}/>
                               <label class="form-check-label">In Transit</label>
                           </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="out_for_delivery" value="something"  onChange={(e)=>filter(e,4)}/>
                               <label class="form-check-label">Out for Delivery</label>
                           </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="delivered" value="something"  onChange={(e)=>filter(e,5)}/>
                               <label class="form-check-label">Delivered</label>
                           </div>
                    </li>
                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="rto_intransit" value="something"  onChange={(e)=>filter(e,19)}/>
                               <label class="form-check-label">RTO In Transit</label>
                           </div>
                    </li>

                    <li class="px-3">
                    <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="rto_delivered" value="something"  onChange={(e)=>filter(e,16)}/>
                               <label class="form-check-label">RTO Delivered</label>
                           </div>
                    </li>
                      <li class="px-3">
                      <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="cancelled" value="something"  onChange={(e)=>filter(e,6)}/>
                               <label class="form-check-label">Cancelled</label>
                           </div>
                    </li> 
                     <li class="px-3">
                     <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="failed" value="something"  onChange={(e)=>filter(e,7)}/>
                               <label class="form-check-label">Failed</label>
                           </div>
                    </li> 
                    <li class="px-3">
                     <div class="form-check">
                               <input class="form-check-input" type="checkbox" id="check1" name="lost" value="something"  onChange={(e)=>filter(e,20)}/>
                               <label class="form-check-label">Lost</label>
                           </div>
                    </li> 
                  
                  </ul>
                </div> 
              </div>
              <div class="col-12 col-md">
                <a onClick={(e)=>getData()} class="btn btn-outline-secondary">Update Results</a>
              </div>
          </div>
        </div>
        <div class="col-12 col-md-6 mb-1">
          <div class="row justify-content-between">
              <div class="col-6 col-md-6">
              
              </div>
              <div class="col-6 col-md-6 text-end">
              <a onClick={downloadExcel} class="btn btn-primary">Download Report</a> 
              </div>
          </div>
        </div>
    </div>
  </div>
</div>

{(isLoading) ?
            <div style={{ backgroundColor: "#f1f5f9", zIndex: 2, height: "100%", width: "100%", position: "absolute", opacity: "0.4" }}>
                <div style={{ left: "47%", top: "45%", position: "absolute" }}>
                    <ReactLoading type={"spin"} color={"#000000"} height={300} width={89} />
                </div>
            </div> : 
<div class="card data_table mb-3 mb_display_none">
  <div class="card-body">
    <div class="table-responsive" >
      <div class="shipm_tablew rounded-3">
        <table class="table align-top table-striped table-hover m-0 table-xl nowrap" ref={tableRef}>
          <thead>
            <tr>
              <th width="250px">Shipment Details</th>
              <th width="200px">Shipping Carrier</th>
              <th>Shipping Fee</th>
              {/* <th>Shipping Zone</th> */}
              <th width="200px">Status</th>
              <th>Customer Details</th>
              <th>Value</th>
              <th>Package Details</th>
              {/* <th>Channel</th> */}
              <th>Warehouse Address</th>
              <th>Product Details</th>
            </tr>				
          </thead>
          { shipstate.map((item)=>
          <tbody>
            <tr class="">
              
              <td>
                <h6><a onClick={()=>openOffdetailcanvasHandler(item)} class="text-primary" style={{cursor:"pointer"}}>AWB {item.carrier_tracking_number!=undefined && item.carrier_tracking_number!=""?item.carrier_tracking_number:""}</a> <a onClick={(e)=>copyAWBToClipboard(item.carrier_tracking_number)} data-bs-toggle="tooltip" title="Copy AWB Number"><i class="bi bi-c-square"></i></a> </h6>
                <div><small>Order ID: {item.order_number} <a onClick={(e)=>copyToClipboard(item.order_number)} data-bs-toggle="tooltip" title="Copy Order Number"><i class="bi bi-c-square"></i></a></small></div>
                <div><small><Moment format="MMM DD YYYY">
                        {new Date(item.created*1000)}
            </Moment> - <Moment format="hh:mm:ss a">
                        {new Date(item.created*1000)}
            </Moment></small></div>
                
              </td>
              <td class="shipment_carrier">
                <h6>{item.service_provider}</h6>
                {/* <img src="assets/images/carriers_logo/dhl.svg" class="img-fluid" /> */}
              </td>
              <td>
                ₹ {item.total_amount}
              </td>
              {/* <td>
                Local Zone
              </td> */}
              <td>
              {item.status==0?<span class="status pickup_awit"> <i class="bi bi-clock"></i> Pending</span>:item.status==10? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO</span>:item.status==19? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO In Transit</span>:item.status==16? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO Delivered</span>:item.status==1?<span class="status pickup_awit"> <i class="bi bi-clock"></i> Pickup Awaited</span>:item.status==2?  <span class="status pickedup"> <i class="bi bi-building-fill-up"></i> Pickedup</span>:item.status==3?  <span class="status in_transit"> <i class="bi bi-truck"></i> In Transit</span>:item.status==4? <span class="status out_f_deli"> <i class="bi bi-rocket-takeoff"></i> Out for Delivery</span>:item.status==5? <span class="status delivered"> <i class="bi bi-check2-all"></i> Delivered</span>:item.status==6? <span class="status cancelled"> <i class="bi bi-x-square"></i> Cancelled</span>:item.status==7? <span class="status failed"> <i class="bi bi-x-octagon"></i> Failed</span>:item.status==8?<span class="status failed"> <i class="bi bi-x-octagon"></i> NDR</span>
              :item.status==20?<span class="status failed"> <i class="bi bi-x-octagon"></i> Lost</span>
              :item.status==15?<span class="status failed"> <i class="bi bi-x-octagon"></i> Booked</span>:item.status==16?<span class="status delivered"> <i class="bi bi-check2-all"></i>RTO Delivered</span>:item.status==17?<span class="status failed"> <i class="bi bi-x-octagon"></i>Pickup Failed</span>:item.status==9?<>  <span class="status pickup_sechdls"> <i class="bi bi-calendar"></i> Pickup Scheduled</span><br/><br/>
                {item.pickup_date!=undefined && item.pickup_date!=""?  <small>on {item.pickup_date!=undefined?item.pickup_date:""} at {item.pickup_time!=undefined?item.pickup_time:""}</small>:""} </>:<span class="badge rounded-pill bg-danger fw-400">Not Available</span>}
              
              </td>
            
                       
                          {item.receiver.map((sub)=>(
              <td>
                {sub.name}
                <div><small>{sub.city} - {sub.pincode}</small></div>
                <div><small>{sub.mobile}</small></div>
              </td>
               ))}
              <td>
                <div><span class="badge rounded-pill bg-warning">{item.payment_mode}</span></div>
              </td>
              <td>
                Dead wt. : {item.total_weight} kg
                <div><small>{item.height} x {item.width} x {item.length} (cm)</small></div>
                Volumetric wt.:  {item.volumetric_weight} Kg  
              </td>
              {/* <td>
              <a href="#" data-bs-toggle="tooltip" title="Direct Sales">Direct Sales</a>
              </td> */}
              <td>
              <a href="#"  data-bs-toggle="popover" data-bs-trigger="hover" data-bs-content="Mumbai WI, Warli, 400001">{item.warehouse_id}</a>
              </td>
              <td>{item.items && item.items.length>0 && item.items[0].item_name.substring(0,20) + '...'} {item.items && item.items.length>1?"+1 items":""}
              </td>
            </tr>
          
          
        
           
           
          
       
          </tbody>
            )}
        </table>
      </div>
    </div>
  </div>
</div>
}

{openOffdetailcanvas && (
  <section class="order_data">
    <div class="offcanvas offcanvas-end show" id="Shipment_data">
    <div class="offcanvas-header shadow-sm">
        <h4 class="offcanvas-title">Shipment #{bookorder.shipment_id}</h4>
        <div class="shipm_tablew">
        {bookorder.status==0?<span class="status under_process"><img src="assets/images/spinner.gif" class="img-fluid" /> Under Processing</span>:bookorder.status==10? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO</span>:bookorder.status==19? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO In Transit</span>:bookorder.status==16? <span class="status rtrn"> <i class="bi bi-arrow-clockwise"></i> RTO Delivered</span>:bookorder.status==1?<span class="status pickup_awit"> <i class="bi bi-clock"></i> Pickup Awaited</span>:bookorder.status==2?  <span class="status pickedup"> <i class="bi bi-building-fill-up"></i> Pickedup</span>:bookorder.status==3?  <span class="status in_transit"> <i class="bi bi-truck"></i> In Transit</span>:bookorder.status==4? <span class="status out_f_deli"> <i class="bi bi-rocket-takeoff"></i> Out for Delivery</span>:bookorder.status==5? <span class="status delivered"> <i class="bi bi-check2-all"></i> Delivered</span>:bookorder.status==6? <span class="status cancelled"> <i class="bi bi-x-square"></i> Cancelled</span>:bookorder.status==7? <span class="status failed"> <i class="bi bi-x-octagon"></i> Failed</span>:bookorder.status==8?<span class="status failed"> <i class="bi bi-x-octagon"></i> NDR</span>
        :bookorder.status==20?<span class="status failed"> <i class="bi bi-x-octagon"></i> Lost</span>
        :bookorder.status==15?<span class="status failed"> <i class="bi bi-x-octagon"></i> Booked</span>:bookorder.status==16?<span class="status delivered"> <i class="bi bi-check2-all"></i>RTO Delivered</span>:bookorder.status==17?<span class="status failed"> <i class="bi bi-x-octagon"></i>Pickup Failed</span>:bookorder.status==9?<>  <span class="status pickup_sechdls"> <i class="bi bi-calendar"></i> Pickup Scheduled</span><br/><br/>
          {bookorder.pickup_date!=undefined && bookorder.pickup_date!=""?  <small>on {bookorder.pickup_date!=undefined?bookorder.pickup_date:""} at {bookorder.pickup_time!=undefined?bookorder.pickup_time:""}</small>:""} </>:<span class="badge rounded-pill bg-danger fw-400">Not Available</span>}
        </div>
        <div class="dropdown text-end">
            <button type="button" class="btn btn-outline-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
            Actions 
            </button>
            <ul class="dropdown-menu">
            {bookorder.carrier_tracking_number?
                                        
            
                <li>
                  <a href={`/create_ticket?order_number=${bookorder.carrier_tracking_number}`} class="dropdown-item"> Raise Ticket</a>
                </li>
                :""}
            </ul>
        </div>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" onClick={(e)=>closeOffdetailcanvasHandler(e)}></button>
    </div>
    {failedstate.failed!=""?   
            <div class="alert alert-danger text-center" role="alert">
              Shipment Failed Due to "{failedstate.failed}"
              </div>:""}
    <div class="offcanvas-body">
    <section>
            


            <div class="">
                <div class="row mt-3 order_box_cont">
                    <div class="col-12 col-md-8 ">
                        
        
                       
        
                        <div class="card border-0 mb-3">
                            <div class="card-body">
                                <div class="d-flex ">
                                    <div class="border-end pe-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="truck" class="lucide lucide-truck"><path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11"></path><path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2"></path><circle cx="7" cy="18" r="2"></circle><path d="M15 18H9"></path><circle cx="17" cy="18" r="2"></circle></svg>
                                    </div>
                                    <div class="ps-3 ">
                                        <h6>Shipping Details</h6>
                                    </div>
                                </div>
                                <hr/>
                                <div class="row">
                                    <div class="col-12 col-md-4 mb-2 shipping_carrier_im">
                                        <img src={`https://cdn.shiprath.com/images/${bookorder.carrier_image}`} alt="" class="img-fluid" title="Fedex Inc."/>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Shipment No.</small>
                                        <p><strong><a href="">{bookorder.shipment_id}</a></strong></p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Order on</small>
                                        <p><a href="">{bookorder.shipment_created_date}</a></p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Shipping Courier</small>
                                        <p>{bookorder.service_provider?bookorder.service_provider:bookorder.carrier_name}</p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Shipping Courier AWB No.</small>
                                        <p><a href="">{bookorder.carrier_tracking_number?bookorder.carrier_tracking_number:""}</a></p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Shipping Courier Service</small>
                                        <p>{bookorder.service_provider}</p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Order Type</small>
                                        <p>{bookorder.mode}</p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Shipment Type</small>
                                        <p>Forward</p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Zone</small>
                                        <p>{bookorder.zone_name}</p>
                                    </div>
                                    <div class="col-6 col-md-4 mb-2">
                                        <small class="text-muted">Courier Rule Applied</small>
                                        <p>N/A</p>
                                    </div>
                                    <div class="col-12 col-md-4 mb-2 desk_display_none">
                                        <div class="d-grid">
                                          <a href="#track_shipment" class="btn btn-outline-secondary btn-block">Track Shipment</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        
                        <div class="card border-0  mb-3">
                            <div class="card-body">
                            <div class="d-flex ">
                                <div class="border-end pe-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-open" class="lucide lucide-package-open"><path d="M20.91 8.84 8.56 2.23a1.93 1.93 0 0 0-1.81 0L3.1 4.13a2.12 2.12 0 0 0-.05 3.69l12.22 6.93a2 2 0 0 0 1.94 0L21 12.51a2.12 2.12 0 0 0-.09-3.67Z"></path><path d="m3.09 8.84 12.35-6.61a1.93 1.93 0 0 1 1.81 0l3.65 1.9a2.12 2.12 0 0 1 .1 3.69L8.73 14.75a2 2 0 0 1-1.94 0L3 12.51a2.12 2.12 0 0 1 .09-3.67Z"></path><line x1="12" x2="12" y1="22" y2="13"></line><path d="M20 13.5v3.37a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13.5"></path></svg>
                                </div>
                                <div class="ps-3 ">
                                    <h6>Package Details</h6>
                                </div>
                            </div>
                            <hr/>
                            <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Applicable Weight (in Kg)</small>
                                                    <p>{bookorder.total_weight}KG</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Dead Weight (in Kg)</small>
                                                    <p>{bookorder.dead_weight}KG</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Volumetric Weight (in kg)</small>
                                                    <p>{bookorder.volumetric_weight}KG</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Dimensions (in cm)</small>
                                                    <p>{bookorder.height} x {bookorder.width} x {bookorder.length}</p>
                                                </div>
                                                <div class="col-12 col-md-6 mb-2">
                                                    <small class="text-muted">Number of Boxes</small>
                                                    <p>1</p>
                                                </div>
                                            </div>
                            </div>
                        </div>
        
        
                        <div class="card border-0 mb-3">
                            <div class="card-body">
                                <div class="d-flex ">
                                    <div class="border-end pe-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package" class="lucide lucide-package"><path d="m7.5 4.27 9 5.15"></path><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path><path d="m3.3 7 8.7 5 8.7-5"></path><path d="M12 22V12"></path></svg>
                                    </div>
                                    <div class="ps-3 ">
                                        <h6>Shipment Details</h6>
                                    </div>
                                </div>
                                <hr/>
                                <div class="row">
                                            <div class="col-12 col-md">
                                                    <h6>Ship From:</h6>
                                                        <small class="text-muted">Sender Name:</small>
                                                        <p>{bookorder.sender[0].name}</p>
                                                        <small class="text-muted">Sender Address:</small>
                                                        <p>{bookorder.sender[0].address},{bookorder.sender[0].city}, {bookorder.sender[0].state} {bookorder.sender[0].pincode}</p>
                                                        <small class="text-muted">Sender Email:</small>
                                                        <p>{bookorder.sender[0].email}</p>
                                                        <small class="text-muted">Sender Mobile:</small>
                                                        <p>{bookorder.sender[0].mobile}</p>
                                                </div>
                                                <div class="col-12 col-md">
                                                    <h6>Ship To:</h6>
                                                        <small class="text-muted">Receiver Name:</small>
                                                        <p>{bookorder.receiver[0].name}</p>
                                                        <small class="text-muted">Receiver Address:</small>
                                                        <p>{bookorder.receiver[0].address},{bookorder.receiver[0].city}, {bookorder.receiver[0].state} {bookorder.receiver[0].pincode}</p>
                                                        <small class="text-muted">Receiver Email:</small>
                                                        <p>{bookorder.receiver[0].email}</p>
                                                        <small class="text-muted">Receiver Mobile:</small>
                                                        <p>{bookorder.receiver[0].mobile}</p>
                                                </div>
                                            </div>
                            </div>
                        </div>
        
        
                        <div class="card border-0  mb-3">
                            <div class="card-body">
                            <div class="d-flex ">
                                <div class="border-end pe-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="dollar-sign" class="lucide lucide-dollar-sign"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                                </div>
                                <div class="ps-3 ">
                                    <h6>Payment Details</h6>
                                </div>
                            </div>
                            <hr/>
                            <div class="row">
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Total Paid Amount</small>
                                                    <p>₹ {bookorder.total_amount}</p>
                                                </div>
                                                <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Payment Mode</small>
                                                    <p>Wallet</p>
                                                </div>
                                                {/* <div class="col-12 col-md-4 mb-2">
                                                    <small class="text-muted">Transaction ID</small>
                                                    <p><a href="">3456789876</a></p>
                                                </div> */}
                                            </div>
                            </div>
                        </div>
        
                        <div class="card border-0 mb-3">
                            <div class="card-body">
                            <div class="d-flex ">
                                <div class="border-end pe-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="shopping-basket" class="lucide lucide-shopping-basket"><path d="m5 11 4-7"></path><path d="m19 11-4-7"></path><path d="M2 11h20"></path><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4"></path><path d="m9 11 1 9"></path><path d="M4.5 15.5h15"></path><path d="m15 11-1 9"></path></svg>
                                </div>
                                <div class="ps-3 ">
                                    <h6>Product Details</h6>
                                </div>
                            </div>
                            <hr/>
                            <div class="table-responsive ">
                                                <table class="table table-light">
                                                    <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        {/* <th>Category</th> */}
                                                        {/* <th>HSN</th> */}
                                                        {/* <th>SKU</th> */}
                                                        <th>Qty</th>
                                                        <th>Unit price</th>
                                                        {/* <th>Discount</th> */}
                                                        {/* <th>Tax</th> */}
                                                        <th>Total</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                      {bookorder.items.map((sub)=>(
                                                    <tr>
                                                        <td>{sub.item_name}</td>
                                                        {/* <td>1689070274414</td> */}
                                                        {/* <td>samsung-A50</td> */}
                                                        {/* <td>1</td> */}
                                                        <td>{sub.item_quantity}</td>
                                                        <td>{sub.item_value}</td>
                                                        {/* <td>100.00</td> */}
                                                        {/* <td>10.00</td> */}
                                                        <td> {bookorder.items.reduce((total, sub) => total + parseFloat(sub.item_value), 0).toFixed(2)}</td>
                                                    </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                            </div>
                        </div>
        
                        
                        
                        
                    </div>
                    <div class="col-12 col-md-4">
                    {/* <section class="bg-white p-3 mb-3">
                        <p>
                            Jaipur <i class="bi bi-arrow-right"></i> Delhi
                            <span class="text-end"><small class="text-muted">Location last updated on 3 May 2022 09:38</small></span>
                        </p>
        
                        
                        <p>Delivery ETA - <span class="text-muted">03-02-2022 @ 23:29</span></p>
                    </section> */}
                    <div class="card border-0 shadow-sm tracking_xb">
                        <div class="card-body">
                            <div class="d-flex ">
                                <div class="border-end pe-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-search" class="lucide lucide-package-search"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><circle cx="18.5" cy="15.5" r="2.5"></circle><path d="M20.27 17.27 22 19"></path></svg>
                                </div>
                                <div class="ps-3 ">
                                    <h6>Tracking Info</h6>
                                </div>
                            </div>
                            <hr/>
                            {trackingstate.track!='' && stateship.shipmentDetail!='' ?
                                            <div class="progress-container  position-relative">
                                              {trackingstate.isLoading==false?
                                               trackingstate.track.history.length>0?
                                               trackingstate.track.history.map((sub)=>(
                                                <div class="step-container">
                                                <div class="step active">
                                                <i class="bi bi-check-circle-fill"></i>
                                                </div>
                                                <div class="progress"></div>
                                                <div class="step-info">
                <h4>{sub.message} </h4>
                <p>{sub.location}</p>
                <p><Moment format="MMM DD YYYY hh:mm:ss a">
                 {(sub.time)}
     </Moment></p>
            </div>
                                                </div>
                                             )) :"No Data Available"  :<ReactLoading type="bubbles" color="#0d6efd" style={{ position: 'absolute', right: '45%', height: '20px', width: '10%' }} />}
                                              
                                            </div>:"No Data Available"}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    </div>
    <div className='offcanvas-backdrop fade show'></div>
 </section>
)}


    </div></div>
    <Footer/></div></div></div>
    </div>
  )
}

export default Reports
